<div [class]='formViewInfo && formViewInfo.style'>

  @if (formViewInfo) {
    <form autocomplete="off" name='form' [formGroup]="formViewInfo.formGroup" class="fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-stretch fx-lt-lg-items-stretch">
      <ng-container [ngTemplateOutlet]="formGroupTemplate" [ngTemplateOutletContext]='formViewInfo'></ng-container>
    </form>
  }

</div>

<ng-template #formGroupContainerTemplate let-item='item'>
  <div [ngStyle]="buildFxStyle(item.config)" [style.max-width]='item.config && item.config.maxWidth' [style.overflow]='"hidden"' class="form-group fx-lt-lg-column fx-lt-lg-justify-start fx-lt-lg-items-center fx-lt-lg-flex-auto" style="gap: 10px">
    <ng-container [ngTemplateOutlet]="formGroupTemplate" [ngTemplateOutletContext]='item'></ng-container>
  </div>
</ng-template>

<ng-template #formGroupTemplate let-items='fields'>
  @for (item of items; track trackByFn(i, item); let i = $index) {
    @if (item.isGroup) {
      @if (item.config && item.config.section) {
        @if (!item.config.section.showIf || item.config.section.showIf(record, dataContainerService)) {
          <mat-accordion>
            <mat-expansion-panel [expanded]='item.config.section.open'>
              <mat-expansion-panel-header>
                @if (item.config.section.title) {
                  <mat-panel-title>
                    {{item.config.section.title | translate}}
                  </mat-panel-title>
                }
                @if (item.config.section.description) {
                  <mat-panel-description>
                    {{item.config.section.description | translate}}
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>
              <ng-container [ngTemplateOutlet]="formGroupContainerTemplate" [ngTemplateOutletContext]='{item:item}'></ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        }
      }
      @if (!item.config || !item.config.section) {
        @if (item.title) {
          <span class='h4'>{{item.title | translate}}</span>
        }
        <ng-container [ngTemplateOutlet]="formGroupContainerTemplate" [ngTemplateOutletContext]='{item:item}'></ng-container>
      }
    }
    @if (!item.isGroup) {
      <form-input-viewer [class]='item.class' [style.flex]="item.flex" [style.max-width]='item.maxWidth' [style.width]='item.width' [formInputDefinition]='item.formInputDefinition' [formGroup]='formViewInfo.formGroup' [data]='record' [dataContainerService]='dataContainerService' [formControlKey]='item.controlKey' [readOnly]='item.isReadOnly' style="gap: 10px"></form-input-viewer>
    }
  }
</ng-template>
